import React from "react";

const RefreshCircleIcon14pxSvgV2 = ({
  size = 14,
  strokeWidth = 2.2,
  className,
  ...props
}) => (
  <svg
    style={{ stroke: "currentColor" }}
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path d="M2.59163 13.6993V17.866" />
    <path
      d="M18.3333 9.99935C18.3333 14.5993 14.6 18.3327 9.99996 18.3327C5.39996 18.3327 2.59163 13.6993 2.59163 13.6993M2.59163 13.6993H6.35829M2.59163 13.6993V17.866M1.66663 9.99935C1.66663 5.39935 5.36663 1.66602 9.99996 1.66602C15.5583 1.66602 18.3333 6.29935 18.3333 6.29935M18.3333 6.29935V2.13268M18.3333 6.29935H14.6333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RefreshCircleIcon14pxSvgV2;
